module.exports = __webpack_public_path__ + "img/spiritual.5f5431dc.jpg";